export default __webpack_public_path__ + "static/media/imagen.96b7750d.png";